export default typeof document !== "undefined"



// WEBPACK FOOTER //
// ./inBrowser.js